
const TechnicalCapabilities = () => {
  const capabilities = [
    {
      title: "Scale Removal Technologies",
      description: "Advanced chemical formulations for effective scale dissolution and prevention in production systems.",
      icon: "ri-flask-line",
      image: "https://public.readdy.ai/ai/img_res/71378596252bca9eeb80709ccd922072.jpg",
      technologies: ["Acid-based dissolvers", "Chelating agents", "Scale inhibitors", "Real-time monitoring"]
    },
    {
      title: "Enhanced Oil Production",
      description: "Cutting-edge chemical solutions to maximize reservoir productivity and extend well life.",
      icon: "ri-oil-line",
      image: "https://readdy.ai/api/search-image?query=Enhanced%20oil%20recovery%20chemical%20injection%20system%20with%20Golden%20Black%20logo%2C%20advanced%20production%20enhancement%20technology%20in%20modern%20oil%20field%20facility&width=600&height=400&seq=oil-production&orientation=landscape",
      technologies: ["Surfactant flooding", "Polymer injection", "Chemical EOR", "Production optimization"]
    },
    {
      title: "Advanced Matrix Stimulation",
      description: "Sophisticated stimulation techniques to improve permeability and enhance well productivity.",
      icon: "ri-pulse-line",
      image: "https://readdy.ai/api/search-image?query=Advanced%20matrix%20stimulation%20equipment%20with%20Golden%20Black%20branding%2C%20sophisticated%20well%20intervention%20technology%20and%20chemical%20injection%20systems&width=600&height=400&seq=matrix-stimulation&orientation=landscape",
      technologies: ["Acid fracturing", "Matrix acidizing", "Diverting agents", "Real-time monitoring"]
    },
    {
      title: "Reservoir Management",
      description: "Comprehensive reservoir analysis and management solutions for optimal field development.",
      icon: "ri-database-2-line",
      image: "https://readdy.ai/api/search-image?query=Modern%20reservoir%20management%20control%20room%20with%20Golden%20Black%20logo%2C%20advanced%20monitoring%20systems%20and%20data%20analysis%20for%20oil%20field%20optimization&width=600&height=400&seq=reservoir-management&orientation=landscape",
      technologies: ["Reservoir modeling", "Production forecasting", "Water management", "Field optimization"]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Technical Capabilities & Expertise
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Golden Black's comprehensive technical capabilities span the entire spectrum of oilfield chemical solutions, 
            from advanced research to field implementation.
          </p>
        </div>

        <div className="space-y-16">
          {capabilities.map((capability, index) => (
            <div key={index} className={`flex flex-col lg:flex-row items-center gap-12 ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
              <div className="lg:w-1/2">
                <img 
                  src={capability.image}
                  alt={capability.title}
                  className="w-full h-80 object-cover rounded-xl shadow-lg"
                />
              </div>
              
              <div className="lg:w-1/2">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                    <i className={`${capability.icon} text-2xl text-teal-600`}></i>
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900">{capability.title}</h3>
                </div>
                
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  {capability.description}
                </p>
                
                <div className="space-y-3">
                  <h4 className="text-lg font-semibold text-gray-900">Key Technologies:</h4>
                  <div className="grid grid-cols-2 gap-3">
                    {capability.technologies.map((tech, techIndex) => (
                      <div key={techIndex} className="flex items-center">
                        <i className="ri-check-line text-teal-600 mr-2"></i>
                        <span className="text-gray-700">{tech}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnicalCapabilities;
